import {observable} from "mobx";
import {consoleApi} from "../apiMiddleware";
import {message} from "antd";
import {StorageType} from "../components/portal/driverComponents/AddStorageDriver";
import * as H from "history";
import {roomStore} from "./RoomStore";
import {miniPersistStore} from "./MiniPersistStore";

export type Admin = {
    company: any,
    createdAt: string,
    email: string,
    emailVerifyed: boolean,
    enable: boolean,
    hash: string,
    id: number,
    name: string,
    orgId: any,
    password: string,
    phone: string,
    salt: string,
    teamId: number,
    updatedAt: string,
};

export type Team = {
    address: string;
    ak: string;
    createdAt: string;
    enable: boolean;
    limit: number,
    name: string,
    sk: string,
    updatedAt: string,
    uuid: string,
};

export type StorageDriversInfType = {
    ak: string,
    sk: string,
    bucket: string,
    region: string,
    path: string,
    provider: StorageType,
    domain?: string,
};

export type StorageDriversArrayInfType = {
    id: number,
    teamId: number,
    provider: StorageType,
    type: string,
    ak: string,
    sk: string,
    bucket: string,
    region: string,
    path: string,
    createdAt: string,
    updatedAt: string,
};

export class TeamStore {
    @observable
    public team: Team | null = null;
    @observable
    public admin: Admin | null = null;
    public async loadMyTeam(history: H.History): Promise<void> {
        try {
            const resp = await consoleApi.user.teamData();
            if (resp.code === 200) {
                this.team = resp.data.team;
                this.admin = resp.data.admin;
            } else {
                this.team = null;
                this.admin = null;
                console.log("Load My Team Fail");
            }
        } catch (err) {
            miniPersistStore.logout(history);
            message.error(err.message);
        }
    }

}
export const teamStore = new TeamStore();



// WEBPACK FOOTER //
// ./src/models/TeamStore.ts